import React from "react";
import Image from "next/image";
import Link from "next/link";

export default function ListPromosi(props) {
  const image = props?.image;

  return (
    <li className="cursor-pointer rounded-lg border bg-white shadow-md transition-all duration-75 hover:scale-105">
      <Link href={`/publikasi/e-brocure/${props.url}`}>
        <a>
          {image ? (
            <div className="relative h-40 w-full p-2">
              <Image
                src={image}
                alt={props.title}
                className="rounded-t-lg bg-cover"
                layout="fill"
                priority={true}
              />
            </div>
          ) : null}
          <div className="flex w-full flex-col gap-1 p-3">
            <h2 className="title-card mb-3 h-[4rem] font-nunito text-xl font-bold capitalize">
              {props.title}
            </h2>

            <div
              className="desc"
              dangerouslySetInnerHTML={{ __html: props.description }}
            ></div>
          </div>
        </a>
      </Link>
    </li>
  );
}
